export class ListToolbarConfigSetSearchEnabledAction {
  constructor(public enabled: boolean) {}
}
